import { render } from "./PageSidebar.vue?vue&type=template&id=d876ffc6&scoped=true"
import script from "./PageSidebar.vue?vue&type=script&lang=js"
export * from "./PageSidebar.vue?vue&type=script&lang=js"

import "./PageSidebar.vue?vue&type=style&index=0&id=d876ffc6&lang=css"
import "./PageSidebar.vue?vue&type=style&index=1&id=d876ffc6&scoped=true&lang=css"

import exportComponent from "/home/marco/docker-devs/laundryrepublic/codebase/lr-epos2-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d876ffc6"]])

export default __exports__